module.exports = __webpack_public_path__ + "img/filter_checked.dec63881.svg";